import { useDemo } from "../hooks/useDemo";
import { Badge } from "@/components/ui";
import { FlaskConical } from "lucide-react";

export function DemoBadge() {
  const { isDemoMode, demoInfo } = useDemo();

  if (!isDemoMode) return null;

  const daysLeft = demoInfo?.days_left;

  return (
    <div className="fixed top-2 right-2 md:top-4 md:right-4 z-50 flex items-center gap-1 md:gap-2">
      <Badge variant="warning" size="md" className="flex items-center gap-1 md:gap-1.5 shadow-lg text-xs md:text-sm">
        <FlaskConical className="w-3 h-3 md:w-3.5 md:h-3.5" />
        <span>Tryb Demo</span>
        {daysLeft !== undefined && (
          <span className="opacity-80">
            ({daysLeft} {daysLeft === 1 ? "dzień" : daysLeft < 5 ? "dni" : "dni"})
          </span>
        )}
      </Badge>
    </div>
  );
}
